// extracted by mini-css-extract-plugin
export default {"wrapperInGameTickets":"InGameTickets_wrapperInGameTickets__zhmEm","header":"InGameTickets_header__alqCK","tabs":"InGameTickets_tabs__6FxKK","content":"InGameTickets_content__xiolG"};